import { Link } from 'react-router-dom'
import type { User } from '@/services/authService'

export function SubscriptionBanner({ user }: { user: User | null }) {
  const t = user?.tenant
  if (!t || t.isSystem) return null

  if (t.subscriptionStatus === 'TRIAL' && t.trialDaysLeft != null && t.trialDaysLeft <= 7) {
    return (
      <div className="bg-amber-100 dark:bg-amber-900/30 text-amber-900 dark:text-amber-100 text-center text-sm py-2 px-4 border-b border-amber-200 dark:border-amber-800">
        Te quedan <strong>{t.trialDaysLeft}</strong> días de prueba Pro.{' '}
        <Link to="/pricing" className="underline font-medium">
          Ver planes
        </Link>
      </div>
    )
  }

  if (t.subscriptionStatus === 'FREE_BASIC') {
    return (
      <div className="bg-slate-100 dark:bg-slate-800 text-slate-800 dark:text-slate-100 text-center text-sm py-2 px-4 border-b border-slate-200 dark:border-slate-700">
        Plan <strong>gratis básico</strong>: límites reducidos; importación/exportación e IA requieren Pro.{' '}
        <Link to="/pricing" className="underline font-medium">
          Mejorar plan
        </Link>
      </div>
    )
  }

  if (t.subscriptionStatus === 'PAST_DUE') {
    return (
      <div className="bg-red-100 dark:bg-red-900/30 text-red-900 dark:text-red-100 text-center text-sm py-2 px-4 border-b border-red-200 dark:border-red-800">
        Hay un problema con el pago. Actualiza tu método en el portal de facturación (Organización → Uso / plan).
      </div>
    )
  }

  return null
}
